export const LAYOUT = {
  HEADER_HEIGHT: 52,
  ITEM_HEIGHT: 44,
  MENU_WIDTH: 260,
  VIEWPORT_MARGIN: 16,
  BOTTOM_PADDING: 32
} as const;

export const DEFAULT_TRIGGER_POSITION = {
  x: typeof window !== "undefined" ? window.innerWidth / 2 : 0,
  y: typeof window !== "undefined" ? window.innerHeight - 100 : 0
};
